import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 14v3h3L17.086 6.914a2 2 0 0 0 0-2.828l-.172-.172a2 2 0 0 0-2.828 0zm-1 6a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1"
    }
  )
);
var SvgEditFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var EditFilled_default = SvgEditFilled;

export { EditFilled_default as default };
